import { ReactComponent as FlagIcon } from "./svg/us-flag.svg";
import "../flag-icon.scss";

export const USFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
